import { Record } from 'immutable';

export class CollectionItem extends new Record({ id: undefined, name: undefined }) {
  constructor(id, name) {
    super({ id, name });
  }
}
